import React, { forwardRef } from 'react';
import { type Input as BaseInput } from 'tamagui';

import { formatWithMask, PHONE_NUMBER_MASK } from '../../utils/maskUtils';
import { Input, type InputProps } from './Input';

export interface PhoneNumberInputProps extends Omit<
    InputProps,
    'onChangeText' | 'value'
> {
    value?: string;
    onChangeText?: (formattedValue: string) => void;
}

export const PhoneNumberInput = forwardRef<BaseInput, PhoneNumberInputProps>(
    (
        {
            value,
            onChangeText,
            placeholder = '(123) 456-7890',
            inputMode = 'tel',
            keyboardType = 'phone-pad',
            autoComplete = 'tel-national',
            ...props
        },
        ref,
    ) => {
        const handleChangeText = (text: string) => {
            const { masked } = formatWithMask(PHONE_NUMBER_MASK, text);
            onChangeText?.(masked);
        };

        return (
            <Input
                ref={ref}
                value={value}
                onChangeText={handleChangeText}
                placeholder={placeholder}
                inputMode={inputMode}
                keyboardType={keyboardType}
                autoComplete={autoComplete}
                {...props}
            />
        );
    },
);
